module.exports = __webpack_public_path__ + "static/media/img-fondo-casos-clinicos-mobile.8c5c6dd2.png";